export const EVENTS_ERROR = 'EVENTS_ERROR';
export const EVENTS_REQUEST = 'EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'EVENTS_SUCCESS';
export const EVENTS_RESET = 'EVENTS_RESET';

